jQuery(document).ready(function ($) {

    const $hdp = $('.bloc_hdp').first()
    if (!$hdp.length) return

    const targets = $hdp.find('h1, .accroche, .localisation, .bouton, #breadcrumbs').get()
    if (!targets.length) return

    gsap.set(targets, { opacity: 0, y: 30 })

    gsap.to(targets, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.15,
        delay: 0.2
    })
})
